'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.init = init;
exports.redirectToCUList = redirectToCUList;
exports.redirectToCUMajorTypes = redirectToCUMajorTypes;

var _reactRouter = require('react-router');

var t = {
    LOAD_HOT_CAREER: '/cu/LOAD_HOT_CAREER',
    LOAD_HOT_CAREER_SUCCESS: '/cu/LOAD_HOT_CAREER_SUCCESS',
    LOAD_HOT_CAREER_FAIL: '/cu/LOAD_HOT_CAREER_FAIL',

    LOAD_HOT_MAJOR: '/cu/LOAD_HOT_MAJOR',
    LOAD_HOT_MAJOR_SUCCESS: '/cu/LOAD_HOT_MAJOR_SUCCESS',
    LOAD_HOT_MAJOR_FAIL: '/cu/LOAD_HOT_MAJOR_FAIL'
};

var initialState = {
    hotMajors: [],
    jobClasses: []
};

// Reducer
function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case t.LOAD_HOT_CAREER_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                jobClasses: action.result.data.data
            });
        case t.LOAD_HOT_MAJOR_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                hotMajors: action.result.data.data
            });
        default:
            return state;
    }
}

function _loadHotCareer() {
    return {
        types: [t.LOAD_HOT_CAREER, t.LOAD_HOT_CAREER_SUCCESS, t.LOAD_HOT_CAREER_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/job/class');
            }

            return promise;
        }()
    };
}

function _loadHotMajor() {
    return {
        types: [t.LOAD_HOT_MAJOR, t.LOAD_HOT_MAJOR_SUCCESS, t.LOAD_HOT_MAJOR_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/major/hot');
            }

            return promise;
        }()
    };
}

function init() {
    return function (dispatch) {
        dispatch(_loadHotCareer());
        dispatch(_loadHotMajor());
    };
}

function redirectToCUList(majorName) {
    return function (dispatch) {
        _reactRouter.browserHistory.push({
            pathname: '/major/culist',
            query: {
                searchName: majorName
            }
        });
    };
}

function redirectToCUMajorTypes(jobClassCode) {
    return function (dispatch) {
        _reactRouter.browserHistory.push({
            pathname: '/major/cumajor_types/' + jobClassCode
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/major/majorHome.js
// module id = 455
// module chunks = 0